





















import {Mixins, Prop} from "vue-property-decorator";
import Component from "vue-class-component";
import {Widget} from "@/components/dashboard/Dashboard.vue";
import Container from "@/components/dashboard/widgets/Container.vue";
import DashboardMixin from "@/mixins/dashboard/DashboardMixin";

const components = {
    Container,
};

@Component({components})

export default class Static extends Mixins(DashboardMixin) {
    @Prop({default: null}) public widget!: Widget;
}
